<template>
    <div class="formCom" v-if="show == null">
      <div class="form">
        <div class="kit-id archive">
          Would you like to reset the KIT Data?
        </div>
        <div class="input-wrap">
          <input
            v-mask="'XX - XX - XXX - XXXX'"
            id="kit-verify"
            type="text"
            class="input"
            @paste="paste"
            @blur="validate"
            placeholder="Confirm Kit ID"
            v-model="verifyKit"
            name="confirm_kit_id"
            v-validate="{ required: true }"
            :class="{ invalid: missmatch || inputempty }"
          />
          <span
            class="validate-error bottom-position"
            v-if="inputempty"
          >
            Your Kit ID is required.
          </span>
          <span
            class="validate-error bottom-position"
            v-else-if="missmatch"
          >
            Kit ID does not match. 
          </span>
        </div>
        <div class="button-wrap">
          <button class="btn btn-reset" @click="login" :disabled = "isButtonDisabled" :style="buttonStyle"  >
            Reset
          </button>
          <button class="btn btn-cancel" @click="closeConfurmModal">
            Close
          </button>
        </div>
      </div>
    </div>
    <div class="formCom" v-else>
      <div class="form-success">
        <div class="kit-id archive">
           The kit has been successfully reset.
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  import CloseIcone from "../../../images/shared/cancel";
  import { parseAndConvertKitId } from "../../mixins/parseAndConvertKitId";
  export default {
    name: "ConfrimEraseModalKit",
    props: ["KitInfo"],  
    mixins: [parseAndConvertKitId],
    data() {
      return {
        show:null,
        CommentTxt: "",
        txt: "",
        email:"",
        verifyKit:"",
        missmatch:false,
        inputempty:false
      }
    },
    components: {
      CloseIcone
    },
    computed: {
    isButtonDisabled() {
      return (
        this.KitInfo.kit_id !== this.parseKitId(this.verifyKit)
      );
    },
    buttonStyle() {
      // Your logic to determine the button's style based on the computed condition
      // For example:
      return this.isButtonDisabled ? { opacity: 0.6 } : {};
    }
  },
    watch: {
      verifyKit() {
      this.verifyKit = this.verifyKit.toUpperCase();
    },
    },
    methods: {
      ...mapActions(["resetKit"]),
      validate(){
        console.log(this.verifyKit);
        if(this.verifyKit === "") {
          this.inputempty = true;
          this.missmatch = false;
        } else if (this.KitInfo.kit_id !== this.parseKitId(this.verifyKit)){
          this.missmatch = true;
          this.inputempty = false;
        } else {
          this.missmatch = false;
          this.inputempty = false;
        }
      },
      closeConfurmModal() {
        this.$emit("closeConfrimEraseModalKit", false);
      },
      async login() {
        if(this.verifyKit === "") {
          this.inputempty = true;
          this.missmatch = false;
          return;
        } else if (this.KitInfo.kit_id !== this.parseKitId(this.verifyKit)){
          this.missmatch = true;
          this.inputempty = false;
          return;
        } else {
          this.missmatch = false;
          this.inputempty = false;
        }
        await this.resetKit(this.KitInfo).then(() => {
          this.show = "success";
          setTimeout(() => {
            this.$emit("closeConfrimEraseModalKit", false);
          }, 5000);
         
        });
      },
      paste(e) {
        e.preventDefault();
      },
    }
  };
  </script>
  
  <style scoped lang="scss">
  @import "../../../styles/_colors.scss";
  .input-wrap {
    margin: 0 0 20px;
    position: relative;
  }
  .formCom {
    background-color: rgba(219, 230, 241, 0.5);
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    z-index: 99;
  }
  .form {
    padding: 30px;
    background-color: #fff;
    max-width: 410px;
    width: 100%;
    position: relative;
    z-index: 1;
    border-radius: 10px;
  }
  .form-success {
    padding: 43px;
    background-color: #fff;
    max-width: 472px;
    width: 100%;
    position: relative;
    z-index: 1;
    border-radius: 10px;
  }
  .form-btn {
    padding: 30px;
    background-color: #fff;
    max-width: 710px;
    width: 100%;
    position: relative;
    z-index: 1;
    border-radius: 10px;
  }
  .button-wrap {
    width: 100%;
    //margin: 10px auto 15px auto;
    display: flex;
    justify-content: space-between;
  }
  .kit-id {
    color: #005eb8;
    font-size: 24px;
    margin: 0 0 10px 0;
    text-align: center;
    font-family: TTNormsMedium, sans-serif;
  }
  .kit-id.archive {
    margin: 0 0 15px 0;
  }
  .btn {
    width: 90px;
    height: 30px;
    background-color: #1546ad;
    color: #fff;
    border-radius: 5px;
    outline: none;
    border: none;
    cursor: pointer;
  }
  .btn-reset {
    margin-left: 40px;
  }

  .btn-cancel {
    margin-right: 40px;
  }
  .saveBtn {
    outline: none;
    border: 1px solid transparent;
    color: #fff;
    width: 150px;
    height: 45px;
    margin: 25px auto 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #62b039;
    border-radius: 25px;
    font-size: 18px;
    transition: all 0.5s linear;
    font-family: TTNormsMedium, sans-serif;
  }
  .saveComment {
    color: green;
    margin: 10px 0 0 0;
    text-align: center;
    font-size: 14px;
    font-family: TTNormsLight, sans-serif;
  }
  .input {
    padding: 17px 20px;
    border-radius: 10px;
    border: 1px solid #c5c5c5;
    color: $gray;
    width: 100%;
    font-size: 16px;
    text-align: center;
    text-transform: uppercase;
    outline: none;
    font-family: TTNormsMedium, sans-serif;
  }
  .input::placeholder {
    color: $lightGray;
    font-size: 16px;
    text-align: center;
    text-transform: none;
    font-family: TTNormsMedium, sans-serif;
  }
  .input.invalid {
  border: 1px solid $red;
  }
  .input:focus {
    border: 1px solid rgb(77, 144, 254);
  }
  .input.invalid:focus {
    border: 1px solid rgb(77, 144, 254);
  }

  </style>
  